<span class="caption">{{ copyrightLeftPart() }} </span>
<mat-icon>copyright</mat-icon>
<span class="caption"> {{ copyrightRightPart() }}</span>
